
/* ------------------------------------------------------
1. Routine Mapping
------------------------------------------------------ */
  let isRenderingStrip = false;
  let routine, currentStep = 0;
  let selectedProducts = [];
  let selectedproductsHandle = [];


  // Custom class added for APP MODE

  document.addEventListener('DOMContentLoaded', function () {

    const isApp = window.ReactNativeWebView || window.appbrew || window.appbrewSDK;

    if (isApp) {
      document.body.classList.add('app-mode');
    }

  });

/* ------------------------------------------------------
2. Session Storage Helpers
------------------------------------------------------ */
function saveState() {
  const state = {
    age: selectedAge,
    secondaryConcern: selectedSecondaryConcern,
    skinType: selectedSkinType,
    skinConcern: selectedSkinConcern,
    currentStep,
    selectedProducts,
    selectedproductsHandle
  };
  sessionStorage.setItem("routineState", JSON.stringify(state));
}


function restoreState() {
  const saved = sessionStorage.getItem("routineState");
  if (!saved) return;

  const state = JSON.parse(saved);

  // Validate required fields
  if (!state.age || !state.skinType || !state.skinConcern || !state.secondaryConcern) return;

  // Restore selections
  selectedAge = state.age;
  selectedSkinType = state.skinType;
  selectedSkinConcern = state.skinConcern;
  selectedSecondaryConcern = state.secondaryConcern;

  // Restore dropdown UI text
  ageSelected.textContent =
    selectedAge;

  skinTypeSelected.textContent =
    selectedSkinType.charAt(0).toUpperCase() + selectedSkinType.slice(1);

  // Rebuild dependent dropdowns in order
  updateSkinConcerns(selectedAge, selectedSkinType);

  skinConcernSelected.textContent =
    selectedSkinConcern.charAt(0).toUpperCase() + selectedSkinConcern.slice(1);

  updateSecondaryConcerns(selectedAge, selectedSkinType, selectedSkinConcern);

  secondaryConcernSelected.textContent = selectedSecondaryConcern;

  // Restore routine using NEW structure

              const routineKey =
              `${selectedAge}_${selectedSkinType}_${selectedSkinConcern}_${selectedSecondaryConcern}`;

            const routine = routineMapping[routineKey];

  if (!routine) return;

  // Restore step + selections
  currentStep = state.currentStep || 0;
  selectedProducts = state.selectedProducts || [];
  selectedproductsHandle = state.selectedproductsHandle || [];

  // Switch to Step 2
  document.getElementById("step1").style.display = "none";
  document.getElementById("step2").style.display = "block";

  // Load routine UI
  loadRoutineSteps().then(() => {
    const tabs = document.querySelectorAll(".routine-tabs li");
    const steps = document.querySelectorAll(".routine-step");
    const nextBtn = document.getElementById("nextBtn");

    tabs.forEach(t => t.classList.remove('active'));
    steps.forEach(s => s.classList.remove('active'));

    tabs[currentStep]?.classList.add('active');
    steps[currentStep]?.classList.add('active');

    // Handle next button visibility
    if (currentStep === tabs.length - 1) {
      renderAllRoutineStrips();
      if (nextBtn) nextBtn.style.display = "none";
    } else {
      if (nextBtn) nextBtn.style.display = "flex";
    }
  });

  // Ensure Start button state correct if user goes back
  checkInputs();
  updateDropdownStates();
  updateTitle()
}



/* ------------------------------------------------------
3. Step 1: Input (custom dropdowns)
------------------------------------------------------ */
  const skinTypeDropdown = document.getElementById('skinTypeDropdown');
  const skinConcernDropdown = document.getElementById('skinConcernDropdown');
  const startBtn = document.getElementById('startBtn');
  const ageDropdown = document.getElementById('ageDropdown');
  const secondaryConcernDropdown = document.getElementById('secondaryConcernDropdown');

  let selectedSkinType = '';
  let selectedSkinConcern = '';
  let selectedAge = '';
  let selectedSecondaryConcern = '';

  const skinTypeSelected = skinTypeDropdown.querySelector('.dropdown-selected');
  const skinConcernSelected = skinConcernDropdown.querySelector('.dropdown-selected');
  const ageSelected = ageDropdown.querySelector('.dropdown-selected');
  const secondaryConcernSelected = secondaryConcernDropdown.querySelector('.dropdown-selected');


  function checkInputs() {
  const isInvalid = !(
    selectedAge &&
    selectedSkinType &&
    selectedSkinConcern &&
    selectedSecondaryConcern
  );

  startBtn.classList.toggle('disabled', isInvalid);
}

  // Create dropdown component
  function setupDropdown(dropdown, type) {
    const selectedEl = dropdown.querySelector('.dropdown-selected');
    const optionsContainer = dropdown.querySelector('.dropdown-options');

    selectedEl.addEventListener('click', () => {
      document.querySelectorAll('.dropdown').forEach(d => d !== dropdown && d.classList.remove('open'));
      dropdown.classList.toggle('open');
    });

    dropdown.addEventListener('click', e => {
      const option = e.target.closest('.option');
      if (!option) return;

      const value = option.dataset.value;
      const text = option.textContent;
      selectedEl.textContent = text;
      dropdown.classList.remove('open');

      // Get the question text dynamically
      const questionText = dropdown.closest('.input-group').querySelector('.byr-qst').innerText.trim();

      if (type === 'age') {
        selectedAge = value;

        // Reset dependent dropdowns
        selectedSkinType = '';
        selectedSkinConcern = '';
        selectedSecondaryConcern = '';

        skinTypeSelected.textContent = 'Select your skin type';
        skinConcernSelected.textContent = 'Select your primary concern';
        secondaryConcernSelected.textContent = 'Select secondary concern';
        startBtn.dataset.question1 = questionText;
        startBtn.dataset.value1 = text;
        updateDropdownStates();

      }

      else if (type === 'skinType') {
        selectedSkinType = value;
        selectedSkinConcern = '';
        selectedSecondaryConcern = '';

        skinConcernSelected.textContent = 'Select your primary concern';
        secondaryConcernSelected.textContent = 'Select secondary concern';
        startBtn.dataset.question2 = questionText;
        startBtn.dataset.value2 = text;

        updateSkinConcerns(selectedAge, value);
        updateDropdownStates();
      }

      else if (type === 'skinConcern') {
        selectedSkinConcern = value;
        selectedSecondaryConcern = '';

        secondaryConcernSelected.textContent = 'Select secondary concern';
        startBtn.dataset.question3 = questionText;
        startBtn.dataset.value3 = text;

        updateSecondaryConcerns(selectedAge, selectedSkinType, value);
        updateDropdownStates();
      }

      else if (type === 'secondaryConcern') {
        selectedSecondaryConcern = value;
        startBtn.dataset.question4 = questionText;
        startBtn.dataset.value4 = text;
      }


      checkInputs();
      updateDropdownStates();
    });

    // Close on outside click
    document.addEventListener('click', e => {
      if (!dropdown.contains(e.target)) dropdown.classList.remove('open');
    });
  }

  function updateSkinConcerns(age, skinType) {
    const optionsContainer = skinConcernDropdown.querySelector('.dropdown-options');
    optionsContainer.innerHTML = '';

    const concerns = new Set();

    Object.keys(routineMapping).forEach(key => {
      const [kAge, kSkinType, kConcern] = key.split('_');

      if (kAge === age && kSkinType === skinType) {
        concerns.add(kConcern);
      }
    });

    concerns.forEach(concern => {
      const div = document.createElement('div');
      div.className = 'option';
      div.dataset.question = "Skin Concern";
      div.dataset.value = concern;
      div.textContent = concern.charAt(0).toUpperCase() + concern.slice(1);
      optionsContainer.appendChild(div);
    });
  }


  function updateSecondaryConcerns(age, skinType, concern) {
  const optionsContainer = secondaryConcernDropdown.querySelector('.dropdown-options');
  optionsContainer.innerHTML = '';

  const secondarySet = new Set();

  Object.keys(routineMapping).forEach(key => {
    const parts = key.split('_');
    const kAge = parts[0];
    const kSkinType = parts[1];
    const kConcern = parts[2];
    const kSecondary = parts.slice(3).join('_');

    if (
      kAge === age &&
      kSkinType === skinType &&
      kConcern === concern
    ) {
      secondarySet.add(kSecondary);
    }
  });

  secondarySet.forEach(item => {
    const div = document.createElement('div');
    div.className = 'option';
    div.dataset.question = "Secondary Concern";
    div.dataset.value = item;
    div.textContent = item;
    optionsContainer.appendChild(div);
  });
}


function updateDropdownStates() {

  // Primary Concern
  const primaryDisabled = !(selectedAge && selectedSkinType);
  skinConcernDropdown.classList.toggle('disabled', primaryDisabled);

  // Secondary Concern
  const secondaryDisabled = !(selectedAge && selectedSkinType && selectedSkinConcern);
  secondaryConcernDropdown.classList.toggle('disabled', secondaryDisabled);

}

  setupDropdown(ageDropdown, 'age');
  setupDropdown(skinTypeDropdown, 'skinType');
  setupDropdown(skinConcernDropdown, 'skinConcern');
  setupDropdown(secondaryConcernDropdown, 'secondaryConcern');

  startBtn.addEventListener('click', async () => {
    console.log("start btn clicked!!");

    const skinTypeError = document.getElementById('skinTypeError');
    const skinConcernError = document.getElementById('skinConcernError');
    const ageError = document.getElementById('ageError');
    const secconcernError = document.getElementById('secondaryConcernError');

    let isValid = true;

    // Validate Skin Type
    if (!selectedSkinType) {
      skinTypeError.style.display = 'block';
      isValid = false;
    } else {
      skinTypeError.style.display = 'none';
    }

    // Validate Skin Concern
    if (!selectedSkinConcern) {
      skinConcernError.style.display = 'block';
      isValid = false;
    } else {
      skinConcernError.style.display = 'none';
    }

    // Validate Age
    if (!selectedAge) {
      ageError.style.display = 'block';
      isValid = false;
    } else {
      ageError.style.display = 'none';
    }

    // Validate Sec concern
    if (!selectedSecondaryConcern) {
      secconcernError.style.display = 'block';
      isValid = false;
    } else {
      secconcernError.style.display = 'none';
    }

    // Stop if invalid
    if (!isValid) return;

    // const routineCombo = routineMapping[selectedSkinType]?.routines?.[selectedSkinConcern];

                const routineKey =
              `${selectedAge}_${selectedSkinType}_${selectedSkinConcern}_${selectedSecondaryConcern}`;

            const routineCombo = routineMapping[routineKey];


    if (!routineCombo) {
      alert("No routine available for this combination.");
      return;
    }

    showLoader();

    await new Promise(requestAnimationFrame);
    routine = routineCombo;
    currentStep = 0;
    selectedProducts = [];
    selectedproductsHandle = [];

    document.getElementById('step1').style.display = "none";
    document.getElementById('step2').style.display = "block";

    await loadRoutineSteps();
    saveState();
    updateTitle();
    hideLoader();
  });

/* ------------------------------------------------------
4. Step 2: Guided Routine with Tabs + Routine Strip + Add to Cart
------------------------------------------------------ */

const tabsContainer = document.querySelector('.routine-tabs');
const contentContainer = document.querySelector('.routine-content');
const nextBtn = document.getElementById('nextBtn');
const backToInputBtn = document.getElementById('backToInput');

async function fetchVariant(productHandle) {
  console.log(productHandle,">>>>>>>>>>>>>>>>>");
  const res = await fetch(`/products/${productHandle}.js`);
  return await res.json();
}

async function loadRoutineSteps() {
  showLoader();
  tabsContainer.innerHTML = "";
  contentContainer.innerHTML = "";

  // const combo = routineMapping[selectedSkinType]?.routines?.[selectedSkinConcern];

   const routineKey =
              `${selectedAge}_${selectedSkinType}_${selectedSkinConcern}_${selectedSecondaryConcern}`;

            const combo = routineMapping[routineKey];


  if (!combo) {
    alert("No routine available for this combination.");
    hideLoader();
    return;
  }

  routine = combo;

  for (let i = 0; i < routine.steps.length; i++) {
    const stepName = routine.steps[i];
    // const product = routine.products[stepName];
    const productKey = routine.products[stepName];
    const product = productLibrary[productKey];

    console.log(product,"??????????");

    const data = await fetchVariant(product.productHandle);
    const variant = data.variants[0];
    const variantId = variant?.id;
    const price = (parseFloat(data.price) / 100).toFixed(2);

    // Check availability
    const inStock = variant?.available === true;

    // Create tab (always render the tab)
    const li = document.createElement('li');
    li.textContent = stepName;
    li.dataset.step = stepName;
    if (i === currentStep) li.classList.add('active');
    tabsContainer.appendChild(li);

    // If product is out of stock, mark the card as disabled
    const outOfStockHTML = `
      <div class="product-card out-of-stock">
        <div class="prd-top">
          <div class="prd-img">
            <img src="${data.featured_image || ''}" alt="${data.title}" width="180">
          </div>
          <div class="prd-desc">
            <p class="card-prd-title"><strong>${data.title.toLowerCase()}</strong></p>
            <p class="card-prd-price">₹${price}</p>
            <p class="out-of-stock-label">Out of Stock</p>
          </div>
        </div>
      </div>
    `;

    // Normal in-stock product card
    const inStockHTML = `
      <div class="product-card">
        <div class="prd-top" data-click-toggle="true">
          <div class="prd-img">
            <img src="${data.featured_image || ''}" alt="${data.title}" width="180">
          </div>
          <div class="prd-desc">
            <div class="usage-frequency"><p class="step-frequency">${product.frequency}</p></div>
            <p class="card-prd-title"><strong>${data.title.toLowerCase()}</strong></p>
            <p class="card-prd-price">₹${price}</p>
          </div>
          <label>
            <input type="checkbox" data-id="${variantId}" data-handle="${product.productHandle}" checked>
          </label>
        </div>
        <div class="prd-bottom">
          <details>
            <summary class="htulabel">How to Use?</summary>
            <ul class="howtouselist">
              ${product.howToUse.map(step => `<li>${step}</li>`).join('')}
            </ul>
          </details>
        </div>
      </div>
    `;

    // Combine full step card
    const div = document.createElement('div');
    div.className = `routine-step ${stepName} ${i === currentStep ? 'active' : ''}`;
    div.innerHTML = `
      <div class="prd-info">${product.info}</div>
      <div class="prd-ingredient-wrapper">
        <div class="prd-ingredient">${product.ingredients}</div>
        <div class="prd-ingredient-info">
          <ul class="ingredientlist">
            ${product.ingredientInfo.map(step => `<li>${step}</li>`).join('')}
          </ul>
        </div>
        ${product.recomdLine ? `<div class="recommendation-line">${product.recomdLine}</div>` : ''}
      </div>

      ${inStock ? inStockHTML : outOfStockHTML}

      <!-- Routine Strip will render below product card -->
      <div class="routine-strip" id="routineStrip-${i}"></div>

      <!-- Add to Cart Button only in the LAST tab -->
      ${i === routine.steps.length - 1 ? `
      <div class="actions">
        <button id="addToCart" class="byr-btn">
          <h3 class="totalprice">Total: ₹<span id="totalPrice">0</span></h3>
          <span>Add to Cart →</span>
        </button>
      </div>` : ""}
    `;

    contentContainer.appendChild(div);

    // Add product only if it's in stock
    if (inStock) {
      if (!selectedProducts.includes(variantId)) selectedProducts.push(variantId);
      if (!selectedproductsHandle.includes(product.productHandle)) selectedproductsHandle.push(product.productHandle);
    }
  }

  attachTabEvents();
  attachCheckboxEvents();
  updateTotalPrice();
  renderAllRoutineStrips();
  resetNextButtonVisibility();

  // --- Reset Next Button Visibility ---
  if (nextBtn) {
    const totalTabs = document.querySelectorAll('.routine-tabs li').length;
    if (totalTabs > 1) {
      nextBtn.style.display = 'block';
    } else {
      nextBtn.style.display = 'none';
    }
  }

  hideLoader();
  saveState();
}

/* ------------------------------------------------------
Routine Strip Logic
------------------------------------------------------ */

// Renders all routine strips below each step card
async function renderAllRoutineStrips() {
  const tabs = document.querySelectorAll('.routine-tabs li');
  if (currentStep === tabs.length - 1) {
    await renderRoutineStrip();
  }
}

// Render individual strip for a tab
async function renderRoutineStrip() {
  if (isRenderingStrip) return; 
  isRenderingStrip = true;

  const lastStepIndex = routine.steps.length - 1;
  const stripId = `routineStrip-${lastStepIndex}`;
  const strip = document.getElementById(stripId);

  if (!strip) {
    isRenderingStrip = false;
    return;
  }

  showLoader();
  strip.innerHTML = '';

  // const combo = routineMapping[selectedSkinType]?.routines?.[selectedSkinConcern];

  const routineKey =
              `${selectedAge}_${selectedSkinType}_${selectedSkinConcern}_${selectedSecondaryConcern}`;

            const combo = routineMapping[routineKey];

  if (!combo) {
    hideLoader();
    isRenderingStrip = false;
    return;
  }

  // Deduplicate selected handles
  selectedproductsHandle = [...new Set(selectedproductsHandle)];

  // Collect info for data attributes
  const selectedNames = [];
  const selectedPrices = [];
  let totalPrice = 0;

  for (let j = 0; j < combo.steps.length; j++) {
    const stepNumber = j + 1;
    const stepName = `Step ${stepNumber}`;
    // const product = combo.products[combo.steps[j]];
    // const phandle = product.productHandle;

    const stepNamee = combo.steps[j];
    const product = combo.products[stepNamee];
    const phandle = productLibrary[product];
    console.log(phandle,"phandle>>>>>>>>>>>>>>>>");

    const isSelected = selectedproductsHandle.includes(phandle.productHandle);
    const data = await fetchVariant(phandle.productHandle);
    const image = data.featured_image || '';
    const productName = data.title || stepName;
    const productPrice = parseFloat(data.price / 100 || 0);

    if (isSelected) {
      selectedNames.push(productName);
      selectedPrices.push(productPrice.toFixed(2));
      totalPrice += productPrice;
    }

    strip.innerHTML += isSelected
      ? `<div class="strip-item">
          <span class="remove-btn" onclick="toggleRoutineSelection('${phandle.productHandle}')">×</span>
          <img src="${image}" alt="Step ${j + 1}">
        </div>`
      : `<div class="strip-item add-item"
            data-step-index="${j}"
            onclick="goToRoutineStep(${j})">
            <p>ADD<br>Step ${j + 1}</p>
        </div>`;

  }

  hideLoader();
  isRenderingStrip = false;

  // Update data attributes for analytics or tracking
  const addToCartBtn = document.getElementById('addToCart');
  if (addToCartBtn) {
    addToCartBtn.dataset.productNames = selectedNames.join(', ');
    addToCartBtn.dataset.productPrices = selectedPrices.join(', ');
    addToCartBtn.dataset.productCount = selectedNames.length;
    addToCartBtn.dataset.totalPrice = totalPrice.toFixed(2);
  }
}




// Toggles selection when clicking × on routine strip
async function toggleRoutineSelection(phandle) {
  const data = await fetchVariant(phandle);
  const variantId = data.variants[0]?.id;

  const checkbox = document.querySelector(`input[data-handle="${phandle}"]`);
  const isChecked = selectedproductsHandle.includes(phandle);

  if (isChecked) {
    selectedProducts = selectedProducts.filter(id => id !== variantId);
    selectedproductsHandle = selectedproductsHandle.filter(h => h !== phandle);
    if (checkbox) checkbox.checked = false;
  } else {
    selectedProducts.push(variantId);
    selectedproductsHandle.push(phandle);
    if (checkbox) checkbox.checked = true;
  }

  updateTotalPrice();
  renderAllRoutineStrips();
  updateAddToCartButtonState()
  saveState();
}

/* ------------------------------------------------------
Checkbox change → update strip and totals
------------------------------------------------------ */
function attachCheckboxEvents() {
  document.querySelectorAll('.routine-step input[type="checkbox"]').forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const pid = parseInt(checkbox.dataset.id);
      const phandle = checkbox.dataset.handle;

      if (checkbox.checked) {
        if (!selectedProducts.includes(pid)) selectedProducts.push(pid);
        if (!selectedproductsHandle.includes(phandle)) selectedproductsHandle.push(phandle);
      } else {
        selectedProducts = selectedProducts.filter(id => id !== pid);
        selectedproductsHandle = selectedproductsHandle.filter(h => h !== phandle);
      }

      updateTotalPrice();
      renderAllRoutineStrips();
      updateAddToCartButtonState();
      saveState();
    });
  });
}

/* ------------------------------------------------------
Tabs Navigation
------------------------------------------------------ */

function attachTabEvents() {
  const tabs = document.querySelectorAll('.routine-tabs li');
  const steps = document.querySelectorAll('.routine-step');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      // Remove active states
      tabs.forEach(t => t.classList.remove('active'));
      steps.forEach(step => step.classList.remove('active'));

      // Activate selected tab + step
      tab.classList.add('active');
      steps[index].classList.add('active');

      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

      // Update current step
      currentStep = index;

      // Update Next Button visibility when using tabs
      if (nextBtn) {
        if (currentStep === tabs.length - 1) {
          nextBtn.style.display = 'none';
        } else {
          nextBtn.style.display = 'block';
        }
      }

      if (currentStep === tabs.length - 1) {
        renderAllRoutineStrips();
      }

      saveState();
    });
  });
}

/* ------------------------------------------------------
Update Total Price Dynamically
------------------------------------------------------ */
async function updateTotalPrice() {
  let total = 0;
  for (let handle of selectedproductsHandle) {
    const data = await fetchVariant(handle);
    total += parseFloat(data.price) / 100;
  }
  const totalEl = document.getElementById('totalPrice');
  if (totalEl) totalEl.textContent = total.toFixed(2);
}

/* ------------------------------------------------------
Add to Cart Button handler WEB/APP
------------------------------------------------------ */

async function websiteAddToCartHandler() {
  const isApp = window.ReactNativeWebView || window.appbrew || window.appbrewSDK;

  // No products selected → safety guard
  if (!selectedProducts || selectedProducts.length === 0) return;

  // --- Loader UI ---
  const addBtn = document.getElementById('addToCart');
  if (addBtn) {
    addBtn.disabled = true;
    const originalHTML = addBtn.innerHTML;
    addBtn.dataset.originalHtml = originalHTML;
    addBtn.innerHTML = `<span class="loading-spinner"></span> Adding...`;
  }

  try {
    
    //  ----APPBREW FLOW----
    
    if (isApp && window.appbrewSDK?.addToCart) {
      for (let variantId of selectedProducts) {
        await window.appbrewSDK.addToCart(
          null, // handle optional
          `gid://shopify/ProductVariant/${variantId}`,
          1
        );
      }

      appBrewgotoCart();
      showToast();

      return;
    }

    //  ----WEB FLOW (Shopify)----

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    const items = selectedProducts.map(id => ({
      id,
      quantity: 1
    }));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items,
        ...(cart && {
          sections: cart.getSectionsToRender().map(s => s.id),
          sections_url: window.location.pathname
        })
      })
    });

    const data = await response.json();

    if (cart) {
      cart.renderContents(data);
      cart.classList.remove('is-empty');
    }

  } catch (err) {
    console.error('Add to cart failed:', err);
  } finally {
    // --- Restore button ---
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.innerHTML = addBtn.dataset.originalHtml;
    }
  }
}

/* ------------------------------------------------------
Add to Cart Button (on last tab only)
------------------------------------------------------ */

document.addEventListener('click', e => {
  const addBtn = e.target.closest('#addToCart');
  if (!addBtn) return;

  websiteAddToCartHandler();
});

/* ------------------------------------------------------
Next Button Logic (No collectStepSelections)
------------------------------------------------------ */

if (nextBtn) {
  nextBtn.addEventListener('click', () => {
    const tabs = document.querySelectorAll('.routine-tabs li');
    const steps = document.querySelectorAll('.routine-step');
    const tabsContainer = document.querySelector('.routine-tabs');

    if (currentStep < tabs.length - 1) {
      // Move forward
      tabs[currentStep].classList.remove('active');
      steps[currentStep].classList.remove('active');

      currentStep++;

      tabs[currentStep].classList.add('active');
      steps[currentStep].classList.add('active');

      // Smoothly scroll active tab into view
      tabs[currentStep].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });

      // Ensure the entire tab bar is visible in the viewport
      tabsContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Hide/Show Next Button correctly
      if (currentStep === tabs.length - 1) {
        nextBtn.style.display = 'none';
      } else {
        nextBtn.style.display = 'block';
      }

      if (currentStep === tabs.length - 1) {
        renderAllRoutineStrips();
      }

      saveState();
    }
  });
}

/* ------------------------------------------------------
Hide Next Button Initially if on Last Tab
------------------------------------------------------ */
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.routine-tabs li');
  if (currentStep === tabs.length - 1) {
    nextBtn.style.display = 'none';
  }
});

// Back → go to Input
backToInputBtn.addEventListener('click', () => {
    document.getElementById('step2').style.display = "none";
    document.getElementById('step1').style.display = "block";
    nextBtn.style.display = "block";
    checkInputs();
});

// Scroll Routine to top

function scrollToRoutineTop() {
    const routineApp = document.getElementById("routineApp");
    if (routineApp) {
        routineApp.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

// Update title as per input

function updateTitle() {
    const titleElement = document.querySelector('.title2');
    if (!titleElement) return;

    const saved = JSON.parse(sessionStorage.getItem('routineState') || '{}');
    if (saved.skinType && saved.skinConcern) {
      const skinType = saved.skinType.charAt(0).toUpperCase() + saved.skinType.slice(1);
      const skinConcern = saved.skinConcern.charAt(0).toUpperCase() + saved.skinConcern.slice(1);
      const secondaryConcern = saved.secondaryConcern.charAt(0).toUpperCase() + saved.secondaryConcern.slice(1);
      titleElement.textContent = `${skinType} + ${skinConcern} + ${secondaryConcern} -Prone Skin`;
    }
  }

/* ------------------------------------------------------
Ensure Next Button resets when routine loads
------------------------------------------------------ */
function resetNextButtonVisibility() {
  const tabs = document.querySelectorAll('.routine-tabs li');
  if (nextBtn) {
    if (tabs.length <= 1) {
      nextBtn.style.display = 'none';
    } else if (currentStep === tabs.length - 1) {
      nextBtn.style.display = 'none';
    } else {
      nextBtn.style.display = 'block';
    }
  }
}

/* ------------------------------------------------------
Ensure ATC Button resets when routine loads
------------------------------------------------------ */
function updateAddToCartButtonState() {
  const addToCartBtn = document.getElementById('addToCart');
  if (!addToCartBtn) return;

  // Check if any product is selected
  if (selectedProducts && selectedProducts.length > 0) {
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
  } else {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
  }
}



/* ------------------------------------------------------
Loader Helpers
------------------------------------------------------ */

function showLoader() {
  const loader = document.getElementById('loader');
  if (loader) loader.style.display = 'flex';
}
function hideLoader() {
  const loader = document.getElementById('loader');
  if (loader) loader.style.display = 'none';
}


/* ------------------------------------------------------
Making prd-card clickable.
------------------------------------------------------ */

document.addEventListener('click', (e) => {
  const prdTop = e.target.closest('.prd-top[data-click-toggle]');
  if (!prdTop) return;

  // If user clicked directly on checkbox, let default behavior happen
  if (e.target.matches('input[type="checkbox"]')) return;

  const checkbox = prdTop.querySelector('input[type="checkbox"]');
  if (!checkbox || checkbox.disabled) return;

  // Toggle checkbox state
  checkbox.checked = !checkbox.checked;

  // Trigger change event so existing logic runs
  checkbox.dispatchEvent(new Event('change', { bubbles: true }));
});


/* ------------------------------------------------------
Tab switch on routine strip item click.
------------------------------------------------------ */

function goToRoutineStep(stepIndex) {
  const tabs = document.querySelectorAll('.routine-tabs li');
  const steps = document.querySelectorAll('.routine-step');
  const tabsContainer = document.querySelector('.routine-tabs');

  if (!tabs[stepIndex] || !steps[stepIndex]) return;

  // Remove current active state
  tabs.forEach(t => t.classList.remove('active'));
  steps.forEach(s => s.classList.remove('active'));

  // Activate target step
  tabs[stepIndex].classList.add('active');
  steps[stepIndex].classList.add('active');
  currentStep = stepIndex;

  // Horizontal scroll to tab
  tabs[stepIndex].scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest'
  });

  // Vertical scroll to product card (with sticky header offset)
  const header = document.querySelector('.site-header');
  const headerOffset = header ? header.offsetHeight + 20 : 120;

  const stepTop = steps[stepIndex].getBoundingClientRect().top;
  const offsetPosition = window.scrollY + stepTop - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });

  // Hide/show Next button correctly
  const nextBtn = document.getElementById('nextBtn');
  if (nextBtn) {
    if (currentStep === tabs.length - 1) {
      nextBtn.style.display = 'none';
    } else {
      nextBtn.style.display = 'block';
    }
  }

  saveState();
}







/* ------------------------------------------------------
Initialize on Page Load
------------------------------------------------------ */
restoreState();








